/* MedBound — popup "Kostenlose Leseprobe".
   Intercetta i link ai PDF di anteprima e apre un modale:
   - "<key>-leseprobe.pdf" (Anatomie, M2, M3): flusso a step -> 2 domande, poi nome + email + telefono,
     poi conferma con link al PDF. Nessun consenso marketing richiesto (per ora non si inviano email/messaggi).
   - "...-anteprima.pdf" (vecchi PDF, es. Heilpraktiker): solo nome + email + telefono.
   Il lead parte via window.mbLead (Google Apps Script -> Google Sheet, un tab per "source"). */
(function () {
  var RED = "#D53A2F", NAVY = "#1E4D6F";

  // Domande per prodotto (chiave = nome del PDF "<key>-leseprobe.pdf")
  var PRODUCTS = {
    anatomie: {
      source: "anteprima-anatomie", label: "Anatomie & Physiologie",
      questions: [
        { id: "q1", title: "Was machst du gerade?", options: ["Pflegeausbildung", "Heilpraktiker-Ausbildung", "Medizinstudium", "Physiotherapie, MTA o. Ä.", "Etwas anderes"] },
        { id: "q2", title: "Wann ist deine nächste Prüfung?", options: ["In weniger als 3 Monaten", "In 3–6 Monaten", "In mehr als 6 Monaten", "Keine Prüfung geplant"] }
      ]
    },
    m2: {
      source: "anteprima-m2", label: "Klinische Medizin – M2",
      questions: [
        { id: "q1", title: "Wann schreibst du dein M2?", options: ["In weniger als 3 Monaten", "In 3–6 Monaten", "In mehr als 6 Monaten", "Weiß ich noch nicht"] },
        { id: "q2", title: "Womit lernst du aktuell?", options: ["AMBOSS", "Via medici", "Lehrbücher & Skripte", "Noch gar nicht"] }
      ]
    },
    heilpraktiker: {
      source: "anteprima-heilpraktiker", label: "Heilpraktiker werden",
      questions: [
        { id: "q1", title: "Wann ist deine schriftliche Überprüfung?", options: ["Im März", "Im Oktober", "Später", "Weiß ich noch nicht"] },
        { id: "q2", title: "Wie bereitest du dich vor?", options: ["Heilpraktikerschule vor Ort", "Fernstudium", "Allein mit Büchern", "Noch gar nicht"] }
      ]
    },
    m3: {
      source: "anteprima-m3", label: "Fälle & Praxis – M3",
      questions: [
        { id: "q1", title: "Wann ist dein M3?", options: ["In weniger als 3 Monaten", "In 3–6 Monaten", "Ich beginne gerade das PJ", "Noch vor dem PJ"] },
        { id: "q2", title: "Was fällt dir am schwersten?", options: ["Patientenvorstellung", "Befunde interpretieren", "Freies Sprechen vor Prüfern", "Praktische Fertigkeiten"] }
      ]
    }
  };

  // Vecchi PDF "-anteprima.pdf" (flusso semplice, senza domande)
  var LEGACY = {
    "band-1": { src: "anteprima-anatomie", label: "Band 1 — Anatomie" },
    "band-2": { src: "anteprima-physiologie", label: "Band 2 — Physiologie" },
    "band-3": { src: "anteprima-biochemie", label: "Band 3 — Biochemie" },
    "band-4": { src: "anteprima-biologie", label: "Band 4 — Biologie & PsychSoz" },
    "bundle": { src: "anteprima-bundle", label: "Mega Bundle" }
  };

  var modal = null, pdfUrl = "", product = null, step = 0, answers = {};

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function build() {
    var css = '<style>' +
      '.mbpv-ov{position:fixed;inset:0;background:rgba(20,30,45,.55);z-index:2147483600;display:none;align-items:center;justify-content:center;padding:18px}' +
      '.mbpv-ov.open{display:flex}' +
      '.mbpv{background:#fff;border-radius:20px;max-width:440px;width:100%;max-height:calc(100vh - 36px);overflow:auto;padding:30px 28px 26px;position:relative;box-sizing:border-box;box-shadow:0 30px 80px rgba(10,20,40,.35);font-family:var(--font-body-family,Montserrat,sans-serif);animation:mbpvIn .22s ease}' +
      '@keyframes mbpvIn{from{transform:translateY(14px) scale(.98);opacity:0}to{transform:none;opacity:1}}' +
      '.mbpv-x{position:absolute;top:6px;right:6px;width:40px;height:40px;border:0;background:none;font-size:26px;line-height:1;color:#9aa1ad;cursor:pointer;z-index:10;display:flex;align-items:center;justify-content:center;padding:0}' +
      '.mbpv-x:hover{color:' + NAVY + '}' +
      '.mbpv button,.mbpv a,.mbpv label,.mbpv-sub,.mbpv-kicker{text-transform:none!important;letter-spacing:normal}' +
      '.mbpv-kicker{letter-spacing:.08em!important;text-transform:uppercase!important}' +
      '.mbpv-prog{display:flex;gap:6px;margin:0 34px 18px 0}' +
      '.mbpv-prog span{flex:1;height:5px;border-radius:99px;background:#e6e9ee}' +
      '.mbpv-prog span.on{background:' + RED + '}' +
      '.mbpv-kicker{font-size:11.5px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:' + RED + ';margin:0 0 6px}' +
      '.mbpv h3{font-family:var(--font-heading-family,"Tomarik Brush","Passion One",sans-serif);font-weight:400;color:' + NAVY + ';font-size:28px;line-height:1.08;margin:0 6px 8px 0}' +
      '.mbpv-sub{font-size:14px;color:#5a6675;line-height:1.5;margin:0 0 16px}' +
      '.mbpv-opts{display:flex;flex-direction:column;gap:8px;margin:4px 0 0}' +
      '.mbpv-opt{display:block;width:100%;text-align:left;border:1.5px solid #dcdce0;border-radius:12px;background:#fff;padding:13px 15px;font:inherit;font-size:14.5px;font-weight:600;color:#26323d;cursor:pointer}' +
      '.mbpv-opt:hover{border-color:' + NAVY + '}' +
      '.mbpv-opt.sel{border-color:' + NAVY + ';background:#edf7fd;color:' + NAVY + ';box-shadow:inset 0 0 0 1px ' + NAVY + '}' +
      '.mbpv label.f{display:block;font-size:12.5px;font-weight:700;color:#3a3a3c;margin:12px 0 5px}' +
      '.mbpv input[type=text],.mbpv input[type=email],.mbpv input[type=tel]{width:100%;box-sizing:border-box;border:1.5px solid #dcdce0;border-radius:11px;padding:12px 14px;font:inherit;font-size:14px;outline:none}' +
      '.mbpv input:focus{border-color:' + NAVY + '}' +
      '.mbpv-telrow{display:flex;gap:8px}' +
      '.mbpv-telrow select{flex:0 0 auto;border:1.5px solid #dcdce0;border-radius:11px;padding:12px 8px;font:inherit;font-size:14px;background:#fff;outline:none;cursor:pointer}' +
      '.mbpv-telrow input{flex:1;min-width:0}' +
      '.mbpv-btn{width:100%;margin-top:18px;background:' + RED + ';color:#fff;border:0;border-radius:99px;padding:15px;font-weight:800;font-size:15px;font-family:inherit;cursor:pointer}' +
      '.mbpv-btn:hover{filter:brightness(.95)}' +
      '.mbpv-btn[disabled]{opacity:.45;cursor:not-allowed;filter:none}' +
      '.mbpv-back{display:block;margin:12px auto 0;border:0;background:none;color:#9aa1ad;font:inherit;font-size:12.5px;cursor:pointer}' +
      '.mbpv-back:hover{color:' + NAVY + '}' +
      '.mbpv-note{font-size:11.5px;color:#9aa1ad;text-align:center;margin:12px 0 0}' +
      '.mbpv-note a{color:#9aa1ad}' +
      '.mbpv-err{display:none;color:' + RED + ';font-size:12.5px;font-weight:700;margin-top:10px}' +
      '.mbpv-ok{text-align:center}' +
      '.mbpv-ok .big{font-family:var(--font-heading-family,"Tomarik Brush","Passion One",sans-serif);font-weight:400;color:' + NAVY + ';font-size:30px;margin:4px 0 10px}' +
      '.mbpv-ok p{font-size:14px;color:#5a6675;line-height:1.55;margin:0 0 8px}' +
      '.mbpv-ok b{color:' + NAVY + '}' +
      '.mbpv-ok a.open{display:inline-block;margin-top:14px;background:' + NAVY + ';color:#fff;text-decoration:none;border-radius:99px;padding:15px 32px;font-weight:800;font-size:16px;box-shadow:0 8px 22px rgba(30,77,111,.32)}' +
      '.mbpv-ok a.open:hover{filter:brightness(1.08)}' +
      '@keyframes mbpvPop{0%{transform:scale(.3);opacity:0}60%{transform:scale(1.18)}100%{transform:scale(1);opacity:1}}' +
      '@keyframes mbpvUp{from{transform:translateY(10px);opacity:0}to{transform:none;opacity:1}}' +
      '.mbpv-check{font-size:46px;line-height:1;color:#1f8a4c;animation:mbpvPop .55s ease both}' +
      '.mbpv-ok p,.mbpv-ok .big,.mbpv-ok a.open{animation:mbpvUp .45s ease both;animation-delay:.12s}' +
      '</style>';
    var div = document.createElement("div");
    div.className = "mbpv-ov"; div.id = "mbpv-ov";
    div.innerHTML = css +
      '<div class="mbpv" role="dialog" aria-modal="true" aria-label="Kostenlose Leseprobe">' +
      '<button type="button" class="mbpv-x" aria-label="Schließen">&times;</button>' +
      '<div id="mbpv-step"></div>' +
      '</div>';
    document.body.appendChild(div);
    modal = div;
    div.addEventListener("click", function (e) { if (e.target === div) close(); });
    div.querySelector(".mbpv-x").addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  function progress() {
    if (!product) return "";
    var n = product.questions.length + 1, h = '<div class="mbpv-prog" aria-hidden="true">';
    for (var i = 0; i < n; i++) h += '<span' + (i <= step ? ' class="on"' : '') + '></span>';
    return h + '</div>';
  }

  function render() {
    var box = modal.querySelector("#mbpv-step");
    if (product && step < product.questions.length) renderQuestion(box, product.questions[step]);
    else renderContact(box);
  }

  function renderQuestion(box, q) {
    var h = progress() +
      '<p class="mbpv-kicker">Kostenlose Leseprobe · ' + esc(product.label) + '</p>' +
      '<h3>' + esc(q.title) + '</h3>' +
      '<p class="mbpv-sub">Damit wir dir die passenden Seiten und Lerntipps schicken.</p>' +
      '<div class="mbpv-opts">';
    q.options.forEach(function (o, i) {
      h += '<button type="button" class="mbpv-opt' + (answers[q.id] === o ? ' sel' : '') + '" data-i="' + i + '">' + esc(o) + '</button>';
    });
    h += '</div>' +
      '<button type="button" class="mbpv-btn" id="mbpv-next"' + (answers[q.id] ? '' : ' disabled') + '>Weiter zur Leseprobe →</button>' +
      (step > 0 ? '<button type="button" class="mbpv-back" id="mbpv-back">← Zurück</button>' : '');
    box.innerHTML = h;
    [].slice.call(box.querySelectorAll(".mbpv-opt")).forEach(function (b) {
      b.addEventListener("click", function () {
        answers[q.id] = q.options[+b.getAttribute("data-i")];
        [].slice.call(box.querySelectorAll(".mbpv-opt")).forEach(function (x) { x.classList.remove("sel"); });
        b.classList.add("sel");
        box.querySelector("#mbpv-next").disabled = false;
      });
    });
    box.querySelector("#mbpv-next").addEventListener("click", function () { if (answers[q.id]) { step++; render(); } });
    var back = box.querySelector("#mbpv-back");
    if (back) back.addEventListener("click", function () { step--; render(); });
  }

  function renderContact(box) {
    var withQ = !!product;
    box.innerHTML = progress() +
      (withQ ? '<p class="mbpv-kicker">Fast geschafft</p><h3>Wohin dürfen wir deine Leseprobe schicken?</h3>'
             : '<h3>Blättere durch die kostenlose Leseprobe</h3>') +
      '<p class="mbpv-sub">Du kannst sie sofort öffnen, zusätzlich schicken wir sie dir per E-Mail.</p>' +
      '<form id="mbpv-form" novalidate>' +
      '<label class="f" for="mbpv-name">Vor- und Nachname <span style="color:' + RED + '">*</span></label>' +
      '<input type="text" id="mbpv-name" required placeholder="Wie heißt du?" autocomplete="name">' +
      '<label class="f" for="mbpv-email">E-Mail <span style="color:' + RED + '">*</span></label>' +
      '<input type="email" id="mbpv-email" required placeholder="du@beispiel.de" autocomplete="email">' +
      '<label class="f" for="mbpv-phone">Telefon <span style="color:#8a8f98;font-weight:400">(freiwillig)</span></label>' +
      '<div class="mbpv-telrow">' +
      '<select id="mbpv-prefix" aria-label="Vorwahl">' +
        '<option value="+49" selected>🇩🇪 +49</option><option value="+43">🇦🇹 +43</option><option value="+41">🇨🇭 +41</option>' +
        '<option value="+39">🇮🇹 +39</option><option value="+33">🇫🇷 +33</option><option value="+34">🇪🇸 +34</option>' +
        '<option value="+44">🇬🇧 +44</option><option value="+31">🇳🇱 +31</option><option value="+32">🇧🇪 +32</option>' +
        '<option value="+48">🇵🇱 +48</option><option value="+351">🇵🇹 +351</option><option value="+352">🇱🇺 +352</option>' +
        '<option value="+1">🇺🇸 +1</option>' +
      '</select>' +
      '<input type="tel" id="mbpv-phone" placeholder="171 1234567" autocomplete="tel-national">' +
      '</div>' +
      '<div class="mbpv-err" id="mbpv-err"></div>' +
      '<button type="submit" class="mbpv-btn">Leseprobe jetzt freischalten</button>' +
      (withQ ? '<button type="button" class="mbpv-back" id="mbpv-back">← Zurück</button>' : '') +
      '<p class="mbpv-note">Kein Spam, versprochen. Mehr in unserer <a href="/pages/privacy" target="_blank" rel="noopener">Datenschutzerklärung</a>.</p>' +
      '</form>';
    box.querySelector("#mbpv-form").addEventListener("submit", onSubmit);
    var back = box.querySelector("#mbpv-back");
    if (back) back.addEventListener("click", function () { step--; render(); });
    setTimeout(function () { var i = box.querySelector("#mbpv-name"); if (i) i.focus(); }, 60);
  }

  function open(url) {
    if (!modal) build();
    pdfUrl = url || "";
    var m = pdfUrl.match(/\/([a-z0-9]+)-leseprobe\.pdf/i);
    product = (m && PRODUCTS[m[1].toLowerCase()]) || null;
    step = 0; answers = {};
    render();
    modal.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function close() { if (modal) { modal.classList.remove("open"); document.body.style.overflow = ""; } }

  function onSubmit(e) {
    e.preventDefault();
    var name = modal.querySelector("#mbpv-name").value.trim();
    var email = modal.querySelector("#mbpv-email").value.trim();
    var prefix = (modal.querySelector("#mbpv-prefix") || {}).value || "";
    var phoneNum = modal.querySelector("#mbpv-phone").value.trim();
    var phone = phoneNum ? (prefix + " " + phoneNum).trim() : "";
    var errEl = modal.querySelector("#mbpv-err");
    function showErr(m) { errEl.style.display = "block"; errEl.textContent = m; }
    if (!name) { showErr("Gib deinen Namen ein."); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showErr("Gib eine gültige E-Mail-Adresse ein (z. B. name@domain.de)."); return; }
    errEl.style.display = "none";

    var src, label;
    if (product) { src = product.source; label = product.label; }
    else {
      var key = ((pdfUrl.match(/(band-[1-4]|bundle)-anteprima/) || [])[1]) || "";
      var b = LEGACY[key] || { src: "anteprima-" + ((location.pathname.split("/").pop() || "home").replace(/\.html$/, "") || "home"), label: "Vorschau" };
      src = b.src; label = b.label;
    }
    var extra = {
      pdf: pdfUrl.split("?")[0],
      // consensi non più richiesti nel modale: restano "no" per non spostare le colonne del foglio
      consent_email: "no",
      consent_whatsapp: "no"
    };
    if (product) product.questions.forEach(function (q) { extra[q.id] = q.title + " → " + (answers[q.id] || ""); });

    try {
      var leads = JSON.parse(localStorage.getItem("mb_preview_leads") || "[]");
      leads.push({ email: email, phone: phone, page: location.pathname, ts: new Date().toISOString() });
      localStorage.setItem("mb_preview_leads", JSON.stringify(leads));
    } catch (err) { }
    if (window.mbLead) window.mbLead({ name: name, email: email, phone: phone, source: src, product: label, extra: extra });
    if (window.fbq) { try { window.fbq("track", "Lead", { content_name: label }); } catch (err) { } }

    var safeMail = esc(email);
    modal.querySelector("#mbpv-step").innerHTML =
      '<div class="mbpv-ok">' +
      '<div class="mbpv-check">✓</div>' +
      '<div class="big">Deine Leseprobe ist bereit!</div>' +
      (pdfUrl
        ? '<p><b>Klick auf den Button, um deine Leseprobe sofort zu öffnen.</b><br>Wir haben sie dir zusätzlich an <b>' + safeMail + '</b> geschickt (schau auch im Spam-Ordner nach).</p>' +
          '<a class="open" href="' + esc(pdfUrl) + '" target="_blank" rel="noopener">📖 Leseprobe jetzt öffnen</a>'
        : '<p>Wir haben dir die Leseprobe an <b>' + safeMail + '</b> geschickt.<br>Schau in dein Postfach (auch in den Spam-Ordner).</p>') +
      '</div>';
  }

  function isPreviewBtn(a) {
    // Riconoscimento dal link (non dal testo): "<key>-leseprobe.pdf" o i vecchi "...-anteprima.pdf"
    var href = (a.getAttribute("href") || "").toLowerCase();
    return /-leseprobe\.pdf/.test(href) || /-anteprima\.pdf/.test(href);
  }
  function bind() {
    [].slice.call(document.querySelectorAll("a")).forEach(function (a) {
      if (a.__mbpv || !isPreviewBtn(a)) return;
      a.__mbpv = true;
      a.addEventListener("click", function (e) { e.preventDefault(); open(a.getAttribute("href") || ""); });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind);
  else bind();
  // ribind nel caso i bottoni vengano renderizzati dopo
  [400, 1200].forEach(function (t) { setTimeout(bind, t); });
})();
